<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1 style="padding-bottom:40px;">Introduction</h1>
<p>In this book, I have tried to make the subject of palmistry as easy as I can for you to learn. It is a very complex subject but it does get easier the more you do it. It is an exact science, so you can’t go wrong. To make things easier to see, you should use some talcum powder and a magnifying glass and a piece of paper for the mess. If you are doing a full reading, it helps to relax the person first. You can do this by either getting the person to give their hands a quick shake or, as I do, hold their hands in yours for about ten to twenty seconds first, to relax them. Just so their fingers are sitting naturally as they are, so you can get a true reading, and always start by asking if they are right or left-handed. Never be shy when you are learning; it is always interesting to see and learn all the different things. I know to this day, as soon as I mention that I do palmistry, the first thing people do is show you their hands and ask about themselves. It certainly makes for interesting conversation.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?7ec0fded